function padNumber(value) {
  return String(value).padStart(2, '0');
}

function formatLocalDate(date) {
  return [
    date.getFullYear(),
    padNumber(date.getMonth() + 1),
    padNumber(date.getDate()),
  ].join('-');
}

function formatLocalDateTime(date) {
  return `${formatLocalDate(date)}T${padNumber(date.getHours())}:${padNumber(date.getMinutes())}`;
}

export function toDateInputValue(value) {
  if (!value) {
    return '';
  }

  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())) {
    return value.trim();
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  return formatLocalDate(date);
}

export function toDateTimeLocalValue(value) {
  if (!value) {
    return '';
  }

  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(value.trim())) {
    return value.trim().slice(0, 16);
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  return formatLocalDateTime(date);
}

export function fromDateInputValue(value, boundary = 'start') {
  if (!value) {
    return '';
  }

  const trimmed = String(value).trim();
  if (!trimmed) {
    return '';
  }

  const date = new Date(
    boundary === 'end'
      ? `${trimmed}T23:59:59.999`
      : `${trimmed}T00:00:00.000`
  );

  if (Number.isNaN(date.getTime())) {
    return '';
  }

  return date.toISOString();
}

export function fromDateTimeLocalValue(value) {
  if (!value) {
    return '';
  }

  const trimmed = String(value).trim();
  if (!trimmed) {
    return '';
  }

  const date = new Date(trimmed);
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  return date.toISOString();
}
